import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router";
import { API } from "../../utils/api";
import { isValidEmail, showToast } from "../../utils/helper";
import ResendOtp from "../Component/ResendOtp";

const ForgotPassword = ({ changeStep }) => {
  const dispatch = useDispatch();

  const [data, setData] = useState({
    email: "",
    otp: "",
    password: "",
    cpassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState("email");
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const updatePassword = () => {
    let isErr = false;
    const errs = {};

    if (!data.password || data.password === "") {
      isErr = true;
      errs.password = "Please enter your new password";
    } else if (data.password.length < 6) {
      isErr = true;
      errs.password = "Password must be at least 6 characters";
    } else if (!data.cpassword || data.cpassword === "") {
      isErr = true;
      errs.cpassword = "Please enter your confirm password";
    } else if (data.password !== data.cpassword) {
      isErr = true;
      errs.cpassword = "Please ensure both passwords match.";
    }

    setErrors(errs);

    if (!loading && !isErr) {
      setLoading(true);

      API.updatePasswordRequest({
        email: data.email,
        newPassword: data.password,
        resetToken: data.resetToken,
      })
        .then((res) => {
          if (res.type === "success") {
            showToast("success", res.message || "Password updated successfully");
            changeStep("Login");
          } else {
            showToast("error", res.message || "Something went wrong");
          }
        })
        .catch((err) => {
          showToast("error", err?.message || "Something went wrong");
        })
        .finally(() => setLoading(false));
    }
  };
  const verifyEmail = () => {
    let isErr = false;
    const errs = {};

    if (!data.otp || data.otp === "") {
      isErr = true;
      errs.otp = "Please enter verification code";
    } else if (data.otp.length !== 6) {
      isErr = true;
      errs.otp = "Please enter valid verificatioin code";
    }

    setErrors(errs);

    if (!loading && !isErr) {
      setLoading(true);

      API.verifyForgotOtpRequest(data)
        .then((res) => {
          if (res.type === "success") {
            setData({
              ...data,
              resetToken: res.resetToken,
            });

            setStep("update");
          } else {
            showToast("error", res.message || "Something went wrong");
          }
        })
        .catch((err) => {
          showToast("error", err?.message || "Something went wrong");
        })
        .finally(() => setLoading(false));
    }
  };
  const submitForm = () => {
    let isErr = false;
    const errs = {};

    if (!data.email || data.email === "") {
      isErr = true;
      errs.email = "Please enter your email address";
    } else if (data.email && !isValidEmail(data.email)) {
      isErr = true;
      errs.email = "Please enter a valid email address";
    }

    setErrors(errs);

    if (!loading && !isErr) {
      setLoading(true);
      API.forgotPasswordRequest(data)
        .then((res) => {
          if (res.type === "success") {
            if (res.message) showToast("success", res.message);
            setStep("verify");
          } else {
            showToast("error", res.message || "Something went wrong");
          }
        })
        .catch((err) => {
          showToast("error", err?.message || "Something went wrong");
        })
        .finally(() => setLoading(false));
    }
  };

  const onChagne = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        if (step === "email") {
          submitForm();
        } else if (step === "verify") {
          verifyEmail();
        } else if (step === "update") {
          updatePassword();
        }
      }}
    >
      {step === "email" && (
        <Form.Group className="form-group with-icon">
          <i className="far fa-envelope" />
          <Form.Control
            type="email"
            name="email"
            value={data.email}
            placeholder="Your Email"
            onChange={(e) => onChagne(e)}
            isInvalid={!!errors.email}
          />
          {errors.email && (
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}

      {step === "verify" && (
        <>
          <Form.Group className="form-group with-icon">
            <i className="far fa-envelope" />
            <Form.Control
              type="email"
              name="email"
              value={data.email}
              placeholder="Your Email"
              disabled
              isInvalid={!!errors.email}
            />
            {errors.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="form-group with-icon">
            <i className="fas fa-lock" />
            <Form.Control
              type="text"
              name="otp"
              value={data.otp || ""}
              placeholder="Verification Code"
              onChange={(e) => onChagne(e)}
              isInvalid={!!errors.otp}
            />
            {errors.otp && (
              <Form.Control.Feedback type="invalid">
                {errors.otp}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <ResendOtp
            onResend={() =>
              API.resendOtp({ email: data.email }).then((res) => {
                if (res.type === "success") {
                  showToast(
                    "success",
                    res.message || "Verification code sent",
                  );
                } else {
                  showToast(
                    "error",
                    res.message || "Failed to resend code",
                  );
                }
              })
            }
          />
        </>
      )}

      {step === "update" && (
        <>
          <Form.Group className="form-group with-icon">
            <i className="fas fa-lock" />
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              value={data.password}
              placeholder="Your password"
              onChange={(e) => onChagne(e)}
              isInvalid={!!errors.password}
            />
            <button
              type="button"
              className="password-toggle"
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword((v) => !v)}
            >
              <i className={`far ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
            </button>
            {errors.password && (
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="form-group with-icon">
            <i className="fas fa-lock" />
            <Form.Control
              type={showCPassword ? "text" : "password"}
              name="cpassword"
              value={data.cpassword}
              placeholder="Confirm Password"
              onChange={(e) => onChagne(e)}
              isInvalid={!!errors.cpassword}
            />
            <button
              type="button"
              className="password-toggle"
              aria-label={showCPassword ? "Hide password" : "Show password"}
              onClick={() => setShowCPassword((v) => !v)}
            >
              <i className={`far ${showCPassword ? "fa-eye-slash" : "fa-eye"}`} />
            </button>
            {errors.cpassword && (
              <Form.Control.Feedback type="invalid">
                {errors.cpassword}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </>
      )}

      <div class="button-wrapper">
        <Button
          type="submit"
          className="btn btn-medium solid"
        >
          {!loading && (
            <span>
              {step === "email"
                ? "Submit"
                : step === "verify"
                ? "Verify"
                : "Update"}
            </span>
          )}
          {loading && <i className="fas fa-spinner fa-pulse loadingIcon" />}
        </Button>
      </div>

      <div className="guide-links ml-auto">
        Already have an account?{" "}
        <span className="link" onClick={() => changeStep("Login")}>
          Login Now
        </span>
      </div>
    </Form>
  );
};

export default ForgotPassword;
